module.exports = __webpack_public_path__ + "static/media/3.ac802e70.png";